import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { SignupForm } from '../components/SignupForm';
import { LoginForm }  from '../components/LoginForm';
import { ResendVerificationForm } from '../components/ResendVerificationForm';
import VerifyEmail from '../components/VerifyEmail';
import { ChangePassword } from '../components/ChangePassword';
import { ForgotPassword } from '../components/ForgotPassword';

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="scientia-container">
    <div className="hero-section">
      <div className="auth-content">
        {children}
      </div>
    </div>
  </div>
);

export const AuthRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="login" element={
        <AuthLayout>
          <LoginForm />
        </AuthLayout>
      } />
      <Route path="signup" element={
        <AuthLayout>
          <SignupForm />
        </AuthLayout>
      } />
      <Route path="resend-verification" element={
        <AuthLayout>
          <ResendVerificationForm />
        </AuthLayout>
      } />
      <Route path="verify-email/:key" element={
        <AuthLayout>
          <VerifyEmail />
        </AuthLayout>
      } />
      <Route path="change-password" element={
        <AuthLayout>
          <ChangePassword />
        </AuthLayout>
      } />
      <Route path="forgot-password" element={
        <AuthLayout>
          <ForgotPassword />
        </AuthLayout>
      } />
    </Routes>
  );
};
